import { createContext, useContext, useState } from "react";

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const [loading, setLoadingState] = useState(false);
  const [message, setMessage] = useState("");
  const [color, setColor] = useState("text-blue-600"); // default color
  // Real progress (0-100) for jobs tracked via useJobProgress. Left
  // undefined for callers that don't have a real number to report —
  // LoadingIndicator falls back to its simulated progress bar in that case.
  const [progress, setProgressState] = useState(undefined);

  const setLoading = (isLoading, msg = "", msgColor = "text-blue-600") => {
    setLoadingState(isLoading);
    setMessage(msg);
    setColor(msgColor);
    setProgressState(undefined);
  };

  const setLoadingProgress = (pct, msg) => {
    setLoadingState(true);
    setProgressState(pct);
    if (msg !== undefined) setMessage(msg);
  };

  return (
    <LoadingContext.Provider value={{ loading, setLoading, message, color, progress, setLoadingProgress }}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => useContext(LoadingContext);
